import Drawer from "react-modern-drawer";
import { Show } from "shared/components";
import { ConfigureMetricsDrawerProps } from "../../types";
import { ConfigureMetrics } from "./ConfigureMetrics";
import { useEffect } from "react";

export const ConfigureMetricsDrawer = (props: ConfigureMetricsDrawerProps) => {
  const { onClose, opened } = props;

  useEffect(() => {
    if (!opened) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [opened, onClose]);

  return (
    <Drawer
      className="rounded-l-lg overflow-hidden"
      direction="right"
      onClose={onClose}
      open={opened}
      size={380}
    >
      <Show if={opened}>
        <ConfigureMetrics {...props} />
      </Show>
    </Drawer>
  );
};
